// extracted by mini-css-extract-plugin
module.exports = {"objectFit":"index-module--objectFit--32M7Q","imagenBox10":"index-module--imagenBox10--1NQmb"};